var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{staticClass:"custom-date-picker",attrs:{"format":"YYYY-MM-DD","type":"date","placeholder":_vm.placeholder},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }